if (!customElements.get('byte-video-with-text')) {
  class ByteVideoWithText extends HTMLElement {
    constructor() {
      super();

      this.activeIndex = 0;
      this.boundHandleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.slideCount = Number.parseInt(this.dataset.slideCount, 10) || 0;

      this.prevButton = this.querySelector('[data-video-text-action="prev"]');
      this.nextButton = this.querySelector('[data-video-text-action="next"]');

      if (this.slideCount >= 2) {
        this.#bindEvents();
      }

      this.#syncTransform();
      this.#scheduleAutoplayActiveSlide();
    }

    disconnectedCallback() {
      this.#unbindEvents();
    }

    handleClick(event) {
      const goToTrigger = event.target.closest('[data-video-text-go-to]');
      if (goToTrigger) {
        const targetIndex = Number.parseInt(goToTrigger.dataset.videoTextGoTo, 10);
        if (!Number.isNaN(targetIndex) && targetIndex >= 0 && targetIndex < this.slideCount) {
          this.#goToIndex(targetIndex);
        }
        return;
      }

      const trigger = event.target.closest('[data-video-text-action]');
      if (!trigger) return;

      const action = trigger.dataset.videoTextAction;

      if (action === 'prev') {
        this.#goToRelative(-1);
      }

      if (action === 'next') {
        this.#goToRelative(1);
      }
    }

    #goToIndex(nextIndex) {
      if (this.slideCount < 1) return;
      if (nextIndex < 0 || nextIndex >= this.slideCount) return;
      if (nextIndex === this.activeIndex) return;

      this.activeIndex = nextIndex;

      if (typeof window.pauseAllMedia === 'function') {
        window.pauseAllMedia();
      }

      this.#syncTransform();
      this.#scheduleAutoplayActiveSlide();
    }

    #goToRelative(delta) {
      if (this.slideCount < 2) return;

      let nextIndex = this.activeIndex + delta;
      if (nextIndex < 0) nextIndex = this.slideCount - 1;
      if (nextIndex >= this.slideCount) nextIndex = 0;

      this.#goToIndex(nextIndex);
    }

    #syncTransform() {
      this.style.setProperty('--byte-vwt-active', String(this.activeIndex));

      const slides = this.querySelectorAll('[data-video-text-slide]');

      for (const [i, slide] of slides.entries()) {
        const isActive = i === this.activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }

      const dots = this.querySelectorAll('[data-video-text-go-to]');
      for (const [i, dot] of dots.entries()) {
        const isActive = i === this.activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      }
    }

    #scheduleAutoplayActiveSlide() {
      if (this.slideCount < 1) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.#tryAutoplayActiveSlide();
        });
      });
    }

    #tryAutoplayActiveSlide() {
      const slides = this.querySelectorAll('[data-video-text-slide]');
      const slide = slides[this.activeIndex];
      if (!slide) return;

      const deferredMedia = slide.querySelector('deferred-media');
      if (!deferredMedia || typeof deferredMedia.loadContent !== 'function') return;

      if (deferredMedia.hasAttribute('loaded')) {
        const video = deferredMedia.querySelector('video');
        if (video) {
          void video.play()?.catch(() => {});
        }
        return;
      }

      deferredMedia.loadContent(false);
    }

    #bindEvents() {
      this.addEventListener('click', this.boundHandleClick);
    }

    #unbindEvents() {
      this.removeEventListener('click', this.boundHandleClick);
    }
  }

  customElements.define('byte-video-with-text', ByteVideoWithText);
}
